// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 162 ? "35a9f203" : chunkId) + "." + {"162":"e77ff07df72bd066","555":"60cdc97a6e79f9c5"}[chunkId] + ".js";
};